import { useCallback } from 'react'

import { useAccount, usePublicClient } from 'wagmi'

import { Hash } from 'types/entities'

import { ERC20 } from 'abis/ERC20'
import { isEther } from 'utils/crypto'

export function useAssetBalance() {
  const { address } = useAccount()

  const { readContract, getBalance } = usePublicClient()
  return useCallback(
    async (token: Hash) => {
      if (!address) {
        return '0'
      }

      if (isEther(token)) {
        const balance = await getBalance({ address })
        return balance.toString()
      }

      const balance = await readContract({
        abi: ERC20,
        address: token,
        args: [address],
        account: address,
        functionName: 'balanceOf',
      })
      return balance.toString()
    },
    [address, readContract],
  )
}
